import { Link } from 'react-router-dom';
import { useState } from 'react';

const SUBSCRIBE_FORM_URL = 'http://adeled.com/';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubscribe = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmitStatus('loading');
    setFormError('');

    try {
      const form = e.currentTarget;
      const honeypotEl = form.querySelector<HTMLInputElement>('[name="phone_alt"]');
      if (honeypotEl && honeypotEl.value.trim() !== '') {
        setSubmitStatus('success');
        setEmail('');
        return;
      }

      const formData = new FormData(form);
      const response = await fetch(SUBSCRIBE_FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === 'OK') {
        setSubmitStatus('success');
        setEmail('');
        setTimeout(() => setSubmitStatus('idle'), 3000);
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.meta?.detail || parsed?.message || responseText || '订阅失败，请稍后重试';
        if (serverMsg.includes('spam')) {
          setSubmitStatus('error');
          setFormError('订阅失败，请稍后重试');
        } else {
          setSubmitStatus('error');
          setFormError(serverMsg);
        }
      }
    } catch {
      setSubmitStatus('error');
      setFormError('网络错误，请稍后重试');
    }
  };

  const footerLinks = {
    navigation: [
      { to: '/', label: '首页' },
      { to: '/category/romance', label: '浪漫爱情' },
      { to: '/category/action', label: '热血动作' },
      { to: '/category/fantasy', label: '奇幻异界' },
      { to: '/about', label: '关于我们' },
    ],
    policy: [
      { to: '#', label: '隐私政策' },
      { to: '#', label: '服务条款' },
    ],
    social: [
      { label: '微博', icon: 'ri-weibo-line' },
      { label: '微信', icon: 'ri-wechat-line' },
      { label: 'B站', icon: 'ri-bilibili-line' },
    ],
  };

  return (
    <footer className="bg-foreground-950 text-background-50 rounded-t-3xl mt-20">
      <div className="w-full px-4 md:px-6 py-16">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-12">
          <div className="md:col-span-1">
            <h4 className="text-2xl font-heading font-bold mb-4">
              订阅更新
            </h4>
            <p className="text-foreground-300 text-sm mb-6 leading-relaxed">
              订阅我们的更新通知，第一时间获取最新漫画上架和热门推荐信息。
            </p>
            <form id="subscribe-form" onSubmit={handleSubscribe} className="space-y-3">
              <input
                type="text"
                name="phone_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="hero-honeypot"
              />
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="输入您的邮箱地址"
                required
                className="w-full bg-transparent border-b border-foreground-600 text-background-50 placeholder-foreground-500 text-sm pb-2 outline-none focus:border-primary-400 transition-colors"
              />
              {formError && (
                <p className="text-accent-400 text-xs">{formError}</p>
              )}
              <button
                type="submit"
                disabled={submitStatus === 'loading'}
                className="px-6 py-2.5 rounded-full bg-background-50 text-foreground-950 text-sm font-medium hover:bg-background-100 transition-all flex items-center gap-2 whitespace-nowrap cursor-pointer disabled:opacity-50"
              >
                {submitStatus === 'loading' ? '提交中...' : submitStatus === 'success' ? '订阅成功 ✓' : '立即订阅'}
                <i className="ri-arrow-right-line"></i>
              </button>
            </form>
          </div>

          <div>
            <h5 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">
              快速导航
            </h5>
            <ul className="space-y-3">
              {footerLinks.navigation.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-foreground-300 text-sm hover:text-background-50 transition-colors underline-offset-4 hover:underline"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h5 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">
              联系我们
            </h5>
            <div className="space-y-3 text-foreground-300 text-sm">
              <p>
                <i className="ri-phone-line mr-2"></i>
                400-888-6666
              </p>
              <p>
                <i className="ri-mail-line mr-2"></i>
                hello@adeled.com
              </p>
            </div>
            <div className="mt-6">
              <h5 className="text-sm font-semibold text-background-50 mb-3 uppercase tracking-wider">
                公司地址
              </h5>
              <p className="text-foreground-300 text-sm leading-relaxed">
                北京市朝阳区望京SOHO<br />
                T1-A座 1208室
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800">
        <div className="w-full px-4 md:px-6 py-6">
          <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-4">
              {footerLinks.social.map((s) => (
                <a
                  key={s.label}
                  href="#"
                  rel="nofollow"
                  className="text-foreground-400 hover:text-background-50 transition-colors text-lg"
                  aria-label={s.label}
                >
                  <i className={s.icon}></i>
                </a>
              ))}
            </div>
            <p className="text-foreground-500 text-xs">
              &copy; {new Date().getFullYear()} 韩漫漫画 版权所有
            </p>
            <div className="flex items-center gap-4">
              {footerLinks.policy.map((link) => (
                <a
                  key={link.label}
                  href={link.to}
                  className="text-foreground-500 text-xs hover:text-background-50 transition-colors whitespace-nowrap"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}